import React, { Component, useState, Fragment } from "react";
import { connect } from "react-redux";

//-- Material
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { notificationActions } from "../../_actions";
import { apiConstants } from "../../_constants/api.constants";
import DatePicker from "react-datepicker";

// import Grid from '@material-ui/core/Grid';
// import DateFnsUtils from '@date-io/date-fns';
// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from '@material-ui/pickers';

//-- CSS for Material
const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#269abc"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey
  },
  contentRoot: {
    padding: theme.spacing(2),
    fontSize: 14,
    width: 600
  },
  actionRoot: {
    margin: 0,
    padding: theme.spacing(1)
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(styles)(props => {
  const { children, classes } = props;
  return (
    <MuiDialogContent dividers className={classes.contentRoot}>
      {children}
    </MuiDialogContent>
  );
});

const DialogActions = withStyles(styles)(props => {
  const { children } = props;
  return <MuiDialogActions>{children}</MuiDialogActions>;
});

class AddEditNotifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultData: {},
      validated: { errors: { title: "", notification_message: "" } },
      notification_date: '',
      notificationStatus: true
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /*
   * componentWillReceiveProps - Whenever Props change, it will call and store data
   * update the state values with new props values, this method will get called whenever any change happens to props values
   */
  componentWillReceiveProps(props) {
    const { defaultData } = props;
    this.setState({
      defaultData
    });
    if (props.popupType === 'AddNotification') {
      this.setState({ defaultData: {}, notification_date: '' })

    }
    if (!props.editOpen) {
      this.setState({
        validated: { errors: { title: "", notification_message: "" } }
      });
    }

    if (props.popupType !== 'AddNotification' && props.userData) {
      let statusData = '';
      if (props.userData.status === 'active') { statusData = true }
      else { statusData = false }

      var d = Date.parse(props.userData.expiry);
      this.setState({ defaultData: props.userData });
      this.setState({ notificationStatus: statusData, notification_date: d });
    }
  }

  handleValidation() {
    const { siteConstants } = this.props.language;

    const fields = this.state.defaultData;
    let formIsValid = true;


    if (fields.title === undefined || fields.title === "") {
      this.setState({
        validated: {
          errors: { title: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }
    if (fields.notification_message === undefined || fields.notification_message == "") {
      this.setState({
        validated: {
          errors: { notification_message: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }

    if (this.state.notification_date === undefined || this.state.notification_date == "") {
      this.setState({
        validated: {
          errors: { notification_date: siteConstants.ERR_CAN_NOT_BLANK }
        }
      });
      formIsValid = false;
      return false;
    }



    return formIsValid;


  }

  handleSubmit = e => {
    e.preventDefault();

    if (this.handleValidation()) {
      let obj = {};
      obj.page = this.props.currentPage;
      obj.orderBy = "id";
      obj.orderByAscDesc = "ASC";
      obj.perPage = 10;
      obj.notification_type = "bell";

      let postData = {};
      postData.notification_type = 'bell';
      postData.title = this.state.defaultData.title;
      postData.notification_message = this.state.defaultData.notification_message;
      if (this.state.defaultData.notification_for)
        postData.notification_for = this.state.defaultData.notification_for;
      else
        postData.notification_for = 'All';
      //postData.notificationValue = this.state.defaultData.notificationValue;
      postData.notification_date = this.state.notification_date;
      this.props.dispatch(
        notificationActions.addNotification(
          apiConstants.ADD_NOTICATIONS,
          postData,
          apiConstants.GET_NOTICATIONS,
          obj
        )
      );

      this.props.funPopupClose("editOpen");
    } else {
      //alert("Form has errors.")
    }
  };

  /*
   *   we are setting the Values
   */
  handleChange = e => {
    const { name, value } = e.target;
    const { defaultData } = this.state;
    this.setState({
      defaultData: {
        ...defaultData,
        [name]: value
      }
    });
  };

  handleDateChange = date => {
    this.setState({
      notification_date: date
    });
  }

  handleStatusChange(e) {
    this.setState({ notificationStatus: e.target.checked });
  }

  render() {

    //console.log("popupType------------------", this.state.defaultData);
    const { siteConstants } = this.props.language;
    let popupType = this.props.popupType;
    if (popupType === "AddNotification") {
      //-- check Add/Edit label
      let addEditTitle = 'Edit Notifications';
      if (this.props.addButton)
        addEditTitle = 'Add Notifications';

      //-- Popup will open on notices page for add/edit the Advertisment
      return (
        <Dialog
          onClose={() => this.props.funPopupClose("editOpen")}
          aria-labelledby="customized-dialog-title"
          open={this.props.editOpen}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={() => this.props.funPopupClose("editOpen")}
            className="editTitle"
          >
            {/* <p className="editTitleTag">{addEditTitle}</p> */}
            {addEditTitle}
          </DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel panel-default">
                  <div className="panel-body">
                    <div className="row">
                      <div className="col">
                        <form role="form">
                          <div className="col-lg-12 mt-3">
                            <div className="form-group">
                              <label>{siteConstants.GEN_TITLE}</label>
                              <input
                                className="form-control"
                                name="title"
                                placeholder={siteConstants.GEN_TITLE}
                                value={this.state.defaultData.title}
                                onChange={this.handleChange}
                              />
                              <span className="my-error">
                                {this.state.validated.errors.title}
                              </span>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.GEN_DESCRIPTION}</label>
                              <textarea
                                className="form-control"
                                placeholder={siteConstants.GEN_DESCRIPTION}
                                name="notification_message"
                                onChange={this.handleChange}
                              >
                                {this.state.defaultData.notification_message}
                              </textarea>
                              <span className="my-error">
                                {this.state.validated.errors.notification_message}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>{siteConstants.NOTIFICATION_FOR}</label>

                              <select
                                className="form-control"
                                name="notification_for"
                                onChange={this.handleChange}
                              >
                                <option value="all">All</option>
                                <option value="User">User</option>
                                <option value="Shopkeeper">Shopkeeper</option>
                              </select>

                              <span className="my-error">
                                {this.state.validated.errors.notification_for}
                              </span>
                            </div>
                          </div>


                          <div className="col-lg-12">
                            <div className="form-group">
                              <label>Expected Date</label>
                              <br />

                              <DatePicker
                                selected={this.state.notification_date}
                                onChange={this.handleDateChange}
                                className="form-control"
                                popperPlacement='top-start'
                              />
                              <span className="my-error">
                                {this.state.validated.errors.notification_date}
                              </span>
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              {/* <button type="button" className="btn btn-primary" onClick={(event) => this.setState({ validated: this.props.funAdvertismentsAddUpdate(event, this.state) })}>{siteConstants.BTN_SAVE}</button>&nbsp; */}
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={this.handleSubmit}
                              >
                                {siteConstants.BTN_SAVE}
                              </button>
                              &nbsp;
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() =>
                                  this.props.funPopupClose("editOpen")
                                }
                              >
                                {siteConstants.BTN_CANCEL}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      );
    } else if (popupType === "") {
      return <div></div>;
    }
  }
}

//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
  const { language } = state;
  return {
    language
  };
}

const connectedAddEditNotifications = connect(mapStateToProps)(AddEditNotifications);
export default connectedAddEditNotifications;
